<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <!--unico -->
      <div class="mt-4 col-lg-8 mt-lg-0">
        <div class="card">
          <div class="card-body">
            <label>Criar Individual</label>
            <div class="row">
              <div class="col-3 col-sm-3 mt-sm-0">
                <label>Indentificação</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="data.identificador "
                />
              </div>
              <div class="col-3 col-sm-3 mt-sm-0">
                <label>Cor</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="data.cor"
                />
              </div>
              <div class="col-3  col-sm-3 mt-sm-0">

                <label >Tipo</label>
                <select
                  id="choices-color-edit"
                  class="form-control"
                  name="choices-color"
                  v-model="data.tipo"
                >
                  <option value="seca" selected>seca</option>
                  <option value="fria">fria</option>
                  <option value="congelada">congelada</option>
                  
                </select>
                 
              </div>

              <div class="col-3  col-sm-3 mt-sm-0">
                <label>Operação</label>
                <select
                  id="choices-category"
                  class="form-control"
                  name="choices-category"
                  v-model="data.operacao_id"
                  
                >
                <option v-for="item in operacoes" :key="item.id" :value="item.id">
                  {{ item.name }}
                </option>
                </select>

              </div>

                              

             
              <div class="mt-5 col-12">
                <div class="d-flex">
                  <button
                    class="mb-0 btn bg-gradient-success btn-sm me-2"
                    type="button"
                    name="button"
                    @click="salvarUnico(data)"
                  >
                    Adicionar Único
                  </button>
                  <button
                    class="mb-0 btn btn-outline-danger btn-sm"
                    type="button"
                    name="button"
                    @click="fecharUnico()"
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--em lote -->
      <div class="mt-4 col-lg-4 mt-lg-0">
        <div class="card">
          <div class="card-body">
            <label>Criar Em Lote</label>
            <div class="row">
              <div class="col-6 col-sm-6 mt-sm-0">
                <label>De</label>
                <input
                  placeholder="1000"
                  class="form-control"
                  type="text"
                  v-model="data.de "
                />
              </div>
              <div class="col-6 col-sm-6 mt-sm-0">
                <label>Até</label>
                <input
                  placeholder="2000"
                  class="form-control"
                  type="text"
                  v-model="data.ate "
                />
              </div>
              <div class="col-4 col-sm-4 mt-sm-0">
                <label>Cor</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="data.cor"
                />
              </div>
              <div class="col-4  col-sm-4 mt-sm-0">

                <label >Tipo</label>
                <select
                  id="choices-color-edit"
                  class="form-control"
                  name="choices-color"
                  v-model="data.tipo"
                >
                  <option value="seca" selected>seca</option>
                  <option value="fria">fria</option>
                  <option value="congelada">congelada</option>
                  
                </select>
                 
              </div>

              <div class="col-4  col-sm-4 mt-sm-0">
                <label>Operação</label>
                <select
                  id="choices-category"
                  class="form-control"
                  name="choices-category"
                  v-model="data.operacao_id"
                  
                >
                <option v-for="item in operacoes" :key="item.id" :value="item.id">
                  {{ item.name }}
                </option>
                </select>

              </div>

                              

             
              <div class="mt-5 col-12">
                <div class="d-flex">
                  <button
                    class="mb-0 btn bg-gradient-success btn-sm me-2"
                    type="button"
                    name="button"
                    @click="salvarEmLote(data)"
                  >
                    Adicionar em Lote
                  </button>
                  <button
                    class="mb-0 btn btn-outline-danger btn-sm"
                    type="button"
                    name="button"
                    @click="fecharUnico()"
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Quill from "quill";
import Choices from "choices.js";

export default {
  name: "FormularioVeiculo",
  props: {
      data: {
        type: Object,
        default: () => {
          {};
        },
      },
      operacoes: {
        type: Array,
        default: () => {
          [];
        },
      },
      salvarUnico: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      salvarEmLote: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      fecharUnico: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      }
    },
  mounted() {


  },
  setup(props) {

      const salvarUnico = (data) => {
          props.salvarUnico(data); // Define o novo cen tro do mapa
      };

      const salvarEmLote = (data) => {
          props.salvarEmLote(data); // Define o novo cen tro do mapa
      };

      const fecharUnico = () => {
          props.fecharUnico(); // Define o novo cen tro do mapa
      };

      // Retorna os métodos ou variáveis que você quer expor
      return {
        salvarUnico,
        salvarEmLote,
        fecharUnico
      };
  }
};
</script>
